<template>
  <div>
    <template v-if="items.length > 0">
      <div v-for="item in items" :key="item">
        <div v-if='item.product.specs.length && item.product.name != "No-Name"' class="product-Spec">{{ item.product.name }}</div>
          <div v-for="spec in item.product.specs" :key="spec">
            <div v-if="spec.display_type_id==4 && spec.values[0].value =='No'">
              
            </div>
            <div v-else >
              <div style="display: flex; margin-bottom: 8px" v-if="spec.values[0].value">
                <div class="type-Spec">
                  {{ $translation(spec.name) }}
                  <div  class="unit" v-if=" spec.unit"> ({{ spec.unit }})</div>
                </div>
                <div v-for="value,j in spec.values" :key="value">
                  <div class="value-Spec" v-if="spec.display_type_id==9 && value.value"> {{value.value.split('T')[0]}}</div>
                  <div class="value-Spec" v-if=" spec.display_type_id != 9 && value.value">{{ value.value }} <span v-if="j<spec.values.length-1">,</span> </div>
                </div> 
              </div>
              
            </div>
        </div>
      </div>
    </template>

    <template v-if="customSpecs.length > 0">
      
      <div v-for="customSpec in customSpecs" :key="customSpec"  >
        <div class="product-Spec">
          
          <div class="type-Spec">{{ customSpec.name }} </div>
          <div class="value-Spec" >{{ customSpec.value }} </div>
          
        </div>
      </div>
     

    </template>
<!--     
    <template v-else>
       No specs. 
    </template> -->
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      customSpecs:[]
    };
  },

  mounted(){
    if(this.$store.getters.productDetails.generalInfo.customSpecs) {
      this.customSpecs = this.$store.getters.productDetails.generalInfo.customSpecs
    }
  },
  computed: {
    items() {
      return this.$store.getters.productDetails.items;
    },
   
  },
};
</script>
<style lang="scss" scoped>
.product-Spec {
  width: 100% !important;
  @include f-body1;
  //text-decoration: underline;
  color: $secondary-color;
  display: flex;
  flex-direction: row;
  margin-bottom: 8px;
}
.type-Spec {
  width: 50%;
  @include f-body3-bold;
  color: $dark-grey2;
  display: flex;
  flex-direction: row;
  .unit{
    @include f-small;
    color: black;
    margin-left: 5px;
  }
}
.value-Spec {
  @include f-body3;
  color: black;
  //width: 100%;
}
</style>